import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  ViewContainerRef,
  OnInit,
  DestroyRef,
  inject,
  effect,
} from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from '@core/services/loader.service';
import { CustomIconService } from '@core/services/custom-icon.service';
import { MatSidenav } from '@angular/material/sidenav';
import { SidebarLoaderService } from '@shared/services/sidebar-loader.service';
import { SideBarComponents } from '@shared/types/side-bar-components.type';
import { Router } from '@angular/router';

@Component({
  selector: 'app-app-root',
  templateUrl: './app-root.component.html',
  styleUrls: ['./app-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppRootComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly loaderService = inject(LoaderService);
  private readonly customIconService = inject(CustomIconService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly sidebarLoaderService = inject(SidebarLoaderService);
  private readonly router = inject(Router);

  @ViewChild('sidebar') sidebar!: MatSidenav;
  @ViewChild('sideBarContainer', { read: ViewContainerRef }) private sideBarContainerRef!: ViewContainerRef;

  public loading = false;
  public readonly loading$: Observable<boolean>;
  readonly currentSidebar = this.sidebarLoaderService.currentSidebar;

  constructor() {
    this.customIconService.registerIcons();

    // this.sidebarLoaderService.sideBarComp$
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((comp: SideBarComponents) => {
    //     this.toggleSideNav(comp);
    //     this.cdr.detectChanges();
    //   });
    // this.sidebarLoaderService.destroyComp$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((destroy) => {
    //   this.onSidebarChange(false);
    //   // this.sidebar.opened = false;
    //   this.sidebar.close();
    //   this.cdr.detectChanges();
    // });
    effect(() => {
      const sidebarComp = this.currentSidebar();
      if (sidebarComp) {
        this.toggleSideNav(sidebarComp);
      } else {
        this.onSidebarChange(false);
        this.sidebar?.close();
      }
    });

    this.loading$ = this.loaderService.isShown$;
  }

  ngOnInit(): void {
    this.loading$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((loading: boolean) => {
      this.loading = loading;
      this.cdr.detectChanges();
    });
  }

  public onSidebarChange(isOpen: boolean): void {
    if (!isOpen && this.sideBarContainerRef) {
      this.sideBarContainerRef.remove();
      this.sideBarContainerRef.clear();
    }
    this.cdr.detectChanges();
  }

  public onSidenavClose(): void {
    this.sidebarLoaderService.destroySideBarComp();
    this.router.navigate([], { queryParams: { trackingNumber: null, zoneId: null }, queryParamsHandling: 'merge' });
  }

  private toggleSideNav(sidebarComp: SideBarComponents): void {
    this.sidebarLoaderService.loadComponent(this.sideBarContainerRef, sidebarComp).then(() => {
      // this.sidebar.toggle();
      this.sidebar.open();
      this.cdr.detectChanges();
    });
  }
}
